import request from '@/utils/http';
import { SRM } from '../constant/constant.js';

export const getRegularRoute = (params = {}) => {
    return request({
        url: `${SRM}/getRouteSupplierRelationByParam`,
        method: 'get',
        params: params
    });
};

export const addRegularRoute = (params = {}) => {
    return request({
        url: `${SRM}/saveRouteSupplierRelationByParam `,
        method: 'post',
        data: params
    });
};
//常跑线路新增
export const supplierCommonRouteAdd = (params = {}) => {
    return request({
        url: `${SRM}/supplierCommonRoute/add`,
        method: 'post',
        data: params
    });
};
//常跑线路编辑
export const supplierCommonRouteModify = (params = {}) => {
    return request({
        url: `${SRM}/supplierCommonRoute/modify`,
        method: 'post',
        data: params
    });
};
//常跑线路删除
export const supplierCommonRouteDel = (params = {}) => {
    return request({
        url: `${SRM}/supplierCommonRoute/deleteBatch`,
        method: 'post',
        data: params
    });
};
//常跑线路编辑记录
export const editRecord = (params = {}) => {
    return request({
        url: `${SRM}/supplierCommonRoute/editRecord`,
        method: 'post',
        data: params
    });
};
//常跑线路审批记录
export const approvalRecord = (params = {}) => {
    return request({
        url: `${SRM}/supplierCommonRoute/approvalRecord`,
        method: 'post',
        data: params
    });
};
//常跑线路审批
export const supplierCommonRouteSubmit = (params = {}) => {
    return request({
        url: `${SRM}/supplierCommonRoute/submit`,
        method: 'post',
        data: params
    });
};
//审批详情页中常跑线路分页接口
export const supplierCommonRoutePage = (params = {}) => {
    return request({
        url: `${SRM}/supplierCommonRoute/page`,
        method: 'post',
        data: params
    });
};
// 常跑线路审批返回供应商信息
export const selectByAuditId = data => {
    return request({
        url: `${SRM}/supplierCommonRoute/selectByAuditId`,
        method: 'get',
        params: data,
    });
};
// 常跑线路详情
export const supplierCommonRouteDetail = data => {
    return request({
        url: `${SRM}/supplierCommonRoute/detail`,
        method: 'get',
        params: data,
    });
};
// 供应商是否存在承运商类别为零担专线
export const isNeedStationInfo = data => {
    return request({
        url: `${SRM}/supplierCommonRoute/isNeedStationInfo`,
        method: 'get',
        params: data,
    });
};

export const delRegularRoute = (params = {}) => {
    return request({
        url: `${SRM}/deleteRouteSupplierRelationByParam `,
        method: 'delete',
        data: params
    });
};